import React from 'react';
import MoneyInput from 'components/MoneyInput';
import { useFormContext } from 'react-hook-form';
import { DisplayHelpers } from 'utils/helpers';
import {
  getInheritedSettings,
  getSourceAndLabel,
  updateProRateCents,
} from '../PositionRateSettingsForm.utils';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const BlendedRateCentsInput = ({ source, inheritedSettings }: Props) => {
  const { setValue, watch } = useFormContext();
  const mergedSettings = getInheritedSettings({ source, inheritedSettings, watch });
  const { field } = getSourceAndLabel(source);

  const { charge_rate_cents, use_blended_rate } = mergedSettings;

  let applicableField = field;

  if (source.includes('w2.local')) {
    applicableField = 'base_margin_percent_w2';
  }

  const baseMarginPercent =
    watch(`${source}.${applicableField}`) || mergedSettings?.[applicableField];

  function onChangeBlendedRate(event: React.FocusEvent<HTMLInputElement>) {
    const blendedRateCents = DisplayHelpers.stringToCents(event.target.value);
    const blendedRateMarkup = blendedRateCents / charge_rate_cents - 1;
    const blendedRateMarkupRounded = Math.round(blendedRateMarkup * 10000) / 10000;

    const isBlendedMarkupValid = blendedRateMarkupRounded >= 0;
    if (isBlendedMarkupValid) {
      setValue(`${source}.blended_rates.blended_rate_markup`, blendedRateMarkupRounded);
    }

    if (use_blended_rate && isBlendedMarkupValid) {
      updateProRateCents({
        setValue,
        watch,
        source,
        baseMarginPercent,
        rateCents: blendedRateCents,
        inheritedSettings,
      });
    }
  }

  return (
    <MoneyInput
      source={`${source}.blended_rate_cents`}
      label="12hr Charge Rate"
      onChange={onChangeBlendedRate}
    />
  );
};
